const VERHOEFF_D = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
  [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
  [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
  [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
  [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
  [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
  [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
  [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
  [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];

const VERHOEFF_P = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
  [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
  [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
  [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
  [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
  [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
  [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

const verhoeffCheck = (num) => {
  let c = 0;
  const digits = String(num).split('').reverse();
  for (let i = 0; i < digits.length; i += 1) {
    c = VERHOEFF_D[c][VERHOEFF_P[i % 8][parseInt(digits[i], 10)]];
  }
  return c === 0;
};

export const normalizeAadhaar = (value) => String(value || '').replace(/\D/g, '').slice(0, 12);

export const formatAadhaarInput = (value) => {
  const digits = normalizeAadhaar(value);
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
};

export const isValidAadhaarNumber = (aadhaar) => {
  if (!/^\d{12}$/.test(aadhaar)) return false;
  if (/^[01]/.test(aadhaar)) return false;
  return verhoeffCheck(aadhaar);
};

const isLikelyDummyValue = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (!normalized) return false;
  if (/^(test|dummy|sample|fake|invalid|xxxx+|0000+|1111+|abcd|asdf|qwerty)/.test(normalized)) {
    return true;
  }
  const digitsOnly = normalized.replace(/\D/g, '');
  if (digitsOnly.length >= 6 && /^(\d)\1+$/.test(digitsOnly)) return true;
  if (digitsOnly === '123456789012' || digitsOnly === '012345678901') return true;
  return false;
};

export const GOVERNMENT_ID_PLACEHOLDERS = {
  aadhar: 'XXXX XXXX XXXX',
  pan: 'ABCDE1234F',
  passport: 'A1234567',
  'driving-license': 'KA-01 20190001234',
  'voter-id': 'ABC1234567',
};

export const validateGovernmentIdNumber = (idType, idNumber) => {
  const raw = String(idNumber ?? '').trim();
  if (!raw) return 'ID number is required';
  if (isLikelyDummyValue(raw)) return 'Enter a valid government ID number';

  switch (idType) {
    case 'aadhar': {
      const digits = normalizeAadhaar(raw);
      if (!isValidAadhaarNumber(digits)) return 'Enter a valid 12-digit Aadhaar number';
      return '';
    }
    case 'pan': {
      const pan = raw.toUpperCase();
      if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(pan)) return 'Enter valid PAN (e.g. ABCDE1234F)';
      return '';
    }
    case 'passport': {
      const passport = raw.toUpperCase();
      if (!/^[A-PR-WY][0-9]{7}$/.test(passport) && !/^[A-Z0-9]{6,12}$/.test(passport)) {
        return 'Enter a valid passport number';
      }
      return '';
    }
    case 'driving-license': {
      const dl = raw.toUpperCase().replace(/\s+/g, ' ').trim();
      const compact = dl.replace(/[\s-]/g, '');
      if (!/^[A-Z]{2}[0-9]{2}[0-9]{11,13}$/.test(compact) && !/^[A-Z0-9]{10,18}$/.test(compact)) {
        return 'Enter a valid driving license number';
      }
      return '';
    }
    case 'voter-id': {
      const voterId = raw.toUpperCase();
      if (!/^[A-Z]{3}[0-9]{7}$/.test(voterId)) return 'Enter valid Voter ID (e.g. ABC1234567)';
      return '';
    }
    default:
      return 'Please select a valid ID type';
  }
};
